import axios from 'axios';
import apiConfig from '../api.config';

export default function getCopyFormConfigCompatibility(hotelId) {
  const {
    host,
    URIs: { getCopyFormConfigCompatibility },
  } = apiConfig;
  const uri = `${host}${getCopyFormConfigCompatibility.replace(':hotelId', hotelId)}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res;
    });
}
